import axios from "axios";
import { getBaseUrl } from "redux/utils";
export const LOGIN_URL = `${getBaseUrl()}/users/login.json`;
export const PRACTICES_URL = `${getBaseUrl()}/practices/listing.json`;

export function login(userName, password) {
  return axios.post(`${LOGIN_URL}`, { username: userName, password });
}

export function getUserByToken(token, init_load) {
  let url = getBaseUrl();
  return axios.get(`${url}/users/user_by_token.json`, {
    params: {
      token: token,
      init_load: init_load,
    },
  });
}
export function getEsyncConfig(){
  let url= getBaseUrl()
  return axios.get(`${url}/configs.json`)
}



export function getPracticesByToken() {
  return axios.get(`${PRACTICES_URL}`);
}
